export class UserData {
    firstName : string = ''
    lastName : string = ''
    email : string = ''
    roomNumber : string = ''
    answer1a : string = ''
    answer1b : string = ''
    answer2a : string = ''
    answer2b : string = ''
    answer3a : string = ''
    answer3b : string = ''
    answer4a1 : string = ''
    answer4a2 : string = ''
    answer4a3 : string = ''
    answer4a4 : string = ''
    answer4b1 : string = ''
    answer4b2 : string = ''
    answer4b3 : string = ''
    answer4b4 : string = ''
    answer4b5 : string = ''
    answer4b6 : string = ''
    answer4c1 : string = ''
    answer4c2 : string = ''
    answer4c3: string = ''
    answer4c4 : string = ''
    answer4c5 : string = ''
    answer4d1 : string = ''
    answer4d2 : string = ''
    answer4d3 : string = ''
    answer4d4 : string = ''
}



// WEBPACK FOOTER //
// ./src/pages/services/UserData.ts